import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/nuinalp_hq.svg")